// import { PDFViewer } from '@react-pdf/renderer';
import React, { Fragment } from 'react';
import Invoice from './pdfSection/Invoice';

const PDFdynamic = ({allData, buyer}) => {
    const today  = new Date();
    const invoice = {
        id: "5df3180a09ea16dc4b95f910",
        invoice_no: "1",
        company: "M/s UNANI OUSHUDHALOY",
        propitor: "Proprietor: Md Meer Monir, mobile: 01923-427460",
        director: "Md Meer Nayeem, mobile: 01679084434",
        address: "Bishwaroad, Sarail, Brahmanbaria",
        trans_date: today.toLocaleString("en-US"),
        items: allData
      }
    return (
        <Fragment>
        {/* <PDFViewer width="1000" height="600" className="app" > */}
            <Invoice invoice={invoice} buyer={buyer}/>
        {/* </PDFViewer> */}
    </Fragment>
    );
};

export default PDFdynamic;